export default "__VITE_ASSET__CPj4_Ors__"